import { RedebinsTemplate } from '@trashlab/sitesapp/src/organizations/redebins/template/index';
import type { OrgRouteConfig } from '@trashlab/sitesapp/src/organizations/types';

// Route components
import { Route as HomeRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/home/index';
import { Route as AboutUsRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/about-us/index';
import { Route as CommercialRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/commercial/index';
import { Route as ContactRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/contact/index';
import { Route as DebrisCalculatorRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/debris-calculator/index';
import { Route as DumpsterRentalGuideRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/dumpster-rental-guide/index';
import { Route as DumpsterSizesRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/dumpster-sizes/index';
import { Route as FaqRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/faq/index';
import { Route as HowWeMeasureUpRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/how-we-measure-up/index';
import { Route as JunkRemovalRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/junk-removal/index';
import { Route as ProhibitedItemsRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/prohibited-items/index';
import { Route as ResidentialRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/residential/index';
import { Route as ServiceAreasRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/service-areas/index';
import { Route as ServiceAreasCountyCityRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/service-areas/$county/$city/index';
import { Route as ServiceAreasCityRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/service-areas/$city/index';
import { Route as ThankYouRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/thank-you/index';

// Cart routes
import { Route as CartRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/cart/$cartId/index';
import { Route as CartThankYouRoute } from '@trashlab/sitesapp/src/organizations/redebins/routes/cart/$cartId/thankyou';

export const TemplateWrapper = RedebinsTemplate;

export const routes: Record<string, OrgRouteConfig> = {
  '/': { component: HomeRoute.options.component },
  '/about-us': { component: AboutUsRoute.options.component },
  '/commercial': { component: CommercialRoute.options.component },
  '/contact': { component: ContactRoute.options.component },
  '/debris-calculator': { component: DebrisCalculatorRoute.options.component },
  '/dumpster-rental-guide': { component: DumpsterRentalGuideRoute.options.component },
  '/dumpster-sizes': { component: DumpsterSizesRoute.options.component },
  '/faq': { component: FaqRoute.options.component },
  '/how-we-measure-up': { component: HowWeMeasureUpRoute.options.component },
  '/junk-removal': { component: JunkRemovalRoute.options.component },
  '/prohibited-items': { component: ProhibitedItemsRoute.options.component },
  '/residential': { component: ResidentialRoute.options.component },
  '/service-areas': { component: ServiceAreasRoute.options.component },
  '/service-areas/$city': {
    component: ServiceAreasCityRoute.options.component,
    params: { parse: ServiceAreasCityRoute.options.params?.parse as NonNullable<OrgRouteConfig['params']>['parse'] },
  },
  '/service-areas/$county/$city': {
    component: ServiceAreasCountyCityRoute.options.component,
    params: { parse: ServiceAreasCountyCityRoute.options.params?.parse as NonNullable<OrgRouteConfig['params']>['parse'] },
  },
  '/order-received': { component: ThankYouRoute.options.component },
  '/cart/$cartId': {
    component: CartRoute.options.component,
    params: { parse: CartRoute.options.params?.parse as NonNullable<OrgRouteConfig['params']>['parse'] },
  },
  '/cart/$cartId/thankyou': {
    component: CartThankYouRoute.options.component,
    params: { parse: CartThankYouRoute.options.params?.parse as NonNullable<OrgRouteConfig['params']>['parse'] },
  },
};
